import { render } from "./Beneficiary.vue?vue&type=template&id=763b141b&scoped=true"
import script from "./Beneficiary.vue?vue&type=script&lang=js"
export * from "./Beneficiary.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=763b141b&scoped=true&lang=css&external"
import "./Beneficiary.vue?vue&type=style&index=1&id=763b141b&lang=css"
import "./Beneficiary.vue?vue&type=style&index=2&id=763b141b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763b141b"]])

export default __exports__